export default {
  COMMENT: 'comment',
  INVITE: 'invite',
  //"MODIFY": "modify",
  POST: 'post',
  RESHARE: 'reshare',
  //"VIEW": "view",
  REQMODERATION: 'req_moderation',
};
